var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-form-item",
          {
            attrs: {
              label: _vm.$t.__(
                "dashboard.forms.TaskSettingForm.label_to_display"
              ),
              prop: "labels"
            }
          },
          [
            _c(
              "el-select",
              {
                staticClass: "wp-4",
                attrs: { multiple: "" },
                model: {
                  value: _vm.form.labels,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "labels", $$v)
                  },
                  expression: "form.labels"
                }
              },
              _vm._l(_vm.labels, function(label) {
                return _c("el-option", {
                  key: label.id,
                  attrs: { label: label.value, value: label.id }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aright mt-5" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: { click: _vm.close }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                type: "primary"
              },
              on: { click: _vm.submitForm }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }